
import axios from "axios";
import { takeToken } from "./validateToken";

const api = axios.create({
  baseURL: process.env.REACT_APP_PUBLIC_URL,
  headers: { 'Content-Type': 'application/json' }
})

api.interceptors.request?.use(
  (req) => {
    req.headers.Authorization = `Bearer ${takeToken()}`;
    return req
  },
  error => error
);

export default api;
